const status = (state) => {
  return state.status
}

const estrutura = (state) => {
  return state.estrutura.value
}

const dados = (state) => {
  return state.dados.value
}

const infoDados = (state) => {
  return {
    loading: state.dados.loading,
    data_coleta: state.dados.data_coleta,
    id_cliente: state.dados.id_cliente,
  }
}

const infoEstrutura = (state) => {
  return {
    loading: state.estrutura.loading,
    data_coleta: state.estrutura.data_coleta,
    id_cliente: state.estrutura.id_cliente,
  }
}

export { status, estrutura, dados, infoDados, infoEstrutura }
